module.exports = __webpack_public_path__ + "img/thumbnail_Dhole_m_normal.e454a920.png";